import React from 'react'
import { Spinner, Container } from 'react-bootstrap';

export const SpinnerComponent: React.FC = () => {
  return (
    <div className="text-center">
    <Spinner animation="border" variant="primary" />
    <p>Loading...</p>
  </div>
  )
}
